import { createSelector } from '@reduxjs/toolkit';
import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { eventOccurrencesNotDeleted } from './event-occurrences-not-deleted';

export const eventOccurrenceByTaskUuid = createSelector(
  eventOccurrencesNotDeleted,
  (eventOccurrences): Map<string, EventOccurrenceViewModel> => {
    const map = new Map<string, EventOccurrenceViewModel>();
    for (const e of eventOccurrences) {
      if (e.taskUuid !== undefined && !map.has(e.taskUuid)) {
        map.set(e.taskUuid, e);
      }
    }
    return map;
  },
);
